import type { YFilter } from '@databases/collab/views/y-filter';
import {
  CollabFilterType,
  MutableCollabFilter,
} from '@databases/model/views/view-filter';
import { DatabaseFilter } from '@databases/types/database/view';

export function getNestedFilter(
  filters: YFilter[],
  id: string,
  indexPath: number[]
): YFilter | undefined {
  let filterGroup = filters;
  let targetFilter;

  for (let i = 0; i < indexPath.length; i++) {
    const currentFilter = filterGroup[indexPath[i]];
    if (
      currentFilter.type === CollabFilterType.AND ||
      currentFilter.type === CollabFilterType.OR
    ) {
      filterGroup = currentFilter.value;
    } else {
      targetFilter = currentFilter;
    }
  }

  if (targetFilter && targetFilter.id === id) {
    return targetFilter;
  } else {
    // Perform linear search and return undefined if manipulation has happened by collaborator that has since removed the filter
  }
}

// TODO: remove getTargetedFilter in follow up when id is implemented for all filters
// and use getNestedFilter instead
export function getTargetedFilter(
  filter: MutableCollabFilter | DatabaseFilter,
  path: number[],
  append?: boolean
): [MutableCollabFilter | DatabaseFilter, number] {
  let currentFilter = filter;
  let pathDepth = 0;

  for (pathDepth; pathDepth < (append ? path.length : path.length - 1); pathDepth++) {
    const filterIndex = path[pathDepth];

    if (
      filterIndex !== undefined &&
      (currentFilter.type === CollabFilterType.AND ||
        currentFilter.type === CollabFilterType.OR)
    ) {
      currentFilter = currentFilter.value[filterIndex];
    } else {
      break;
    }
  }

  return [currentFilter, pathDepth];
}
